export const stylesGenericInputErrorCP = {
  wrapper: {
    fontSize: "12px",
    color: "#af272f",
    fontFamily: "AMX-Regular",
  },
  paragraph: {},
};

export const stylesGenericInputErrorTelcel = {
  wrapper: {
    fontSize: "12px",
    color: "#D32222",
    fontFamily: "AMX-Regular",  
    fontWeight: "400",  
    paddingLeft: "16px",
  },
  paragraph: {
    marginTop: "6px"
  },
};
